import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectChangesToYourJourneyStep = (state) => state.get('changesToYourJourneyStep');

const makeSelectChangesToYourJourneyStep = () => createSelector(
  selectChangesToYourJourneyStep,
  (changesToYourJourneyStepState) => ({
    tripCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'tripCancellation']),
      ''
    ),

    reasonForTripCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonForTripCancellation']),
      ''
    ),

    reasonForTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonForTravelCancellation']),
      ''
    ),

    areYouCancellingTheTripDueToMedicalReasons: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'areYouCancellingTheTripDueToMedicalReasons']),
      ''
    ),

    dateTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateTravelCancellation']),
      ''
    ),

    nameOfPersonHavingSicknessTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfPersonHavingSicknessTravelCancellation']),
      ''
    ),

    dateOfBirthTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfBirthTravelCancellation']),
      ''
    ),

    relationshipToClaimantTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'relationshipToClaimantTravelCancellation']),
      ''
    ),

    dateSicknessOrInjuryBeganTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateSicknessOrInjuryBeganTravelCancellation']),
      ''
    ),

    dateEndedTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateEndedTravelCancellation']),
      ''
    ),

    natureOfSicknessOrInjuryTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'natureOfSicknessOrInjuryTravelCancellation']),
      ''
    ),

    fromDateTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'fromDateTravelCancellation']),
      ''
    ),

    toDateTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'toDateTravelCancellation']),
      ''
    ),

    lossInformationItemsTravelCancellation: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'lossInformationItemsTravelCancellation']) && changesToYourJourneyStepState.getIn(['form', 'lossInformationItemsTravelCancellation']).toJS(), ''),
    insuredsTravelCancellation: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'insuredsTravelCancellation']) && changesToYourJourneyStepState.getIn(['form', 'insuredsTravelCancellation']).toJS(), ''),
    enableTimeTravelCancellation: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'enableTimeTravelCancellation']), null),

    // Trip Cancellation for Any Reason
    tripCancellationForAnyReason: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'tripCancellationForAnyReason']),
      ''
    ),

    areYouCancellingTheTripDueToMedicalReasonsForAnyReason: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'areYouCancellingTheTripDueToMedicalReasonsForAnyReason']),
      ''
    ),

    dateTripCancellationForAnyReason: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateTripCancellationForAnyReason']),
      ''
    ),

    reasonForTripCancellationForAnyReason: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonForTripCancellationForAnyReason']),
      ''
    ),

    lossInformationItemsTripCancellationForAnyReason: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'lossInformationItemsTripCancellationForAnyReason']) && changesToYourJourneyStepState.getIn(['form', 'lossInformationItemsTripCancellationForAnyReason']).toJS(), ''),
    insuredsTripCancellationForAnyReason: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'insuredsTripCancellationForAnyReason']) && changesToYourJourneyStepState.getIn(['form', 'insuredsTripCancellationForAnyReason']).toJS(), ''),
    travelSuppliersTripCancellationForAnyReason: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'travelSuppliersTripCancellationForAnyReason']) && changesToYourJourneyStepState.getIn(['form', 'travelSuppliersTripCancellationForAnyReason']).toJS(), ''),

    // Trip Interruption
    travelInterruption: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'travelInterruption']),
      ''
    ),

    reasonsForTripInterruption: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonsForTripInterruption']),
      ''
    ),

    dateTripInterrupted: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateTripInterrupted']),
      ''
    ),

    reasonForInterruption: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonForInterruption']),
      ''
    ),

    nameOfPersonHavingSickness: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfPersonHavingSickness']),
      ''
    ),

    dateOfBirth: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfBirth']),
      ''
    ),

    relationshipToClaimant: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'relationshipToClaimant']),
      ''
    ),

    dateSicknessOrInjuryBegan: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateSicknessOrInjuryBegan']),
      ''
    ),

    dateEnded: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateEnded']),
      ''
    ),

    natureOfSicknessOrInjury: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'natureOfSicknessOrInjury']),
      ''
    ),

    periodOfHospitalization: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'periodOfHospitalization']),
      ''
    ),

    fromDate: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'fromDate']),
      ''
    ),

    toDate: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'toDate']),
      ''
    ),

    // version 14 and above
    whoSickOrInjuredCusingTheCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whoSickOrInjuredCusingTheCancellation']),
      ''
    ),
    whoHadDiedCausingTheCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whoHadDiedCausingTheCancellation']),
      ''
    ),
    nameOfServiceCallingToActiveDuty: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfServiceCallingToActiveDuty']),
      ''
    ),
    whenWereYouNotified: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whenWereYouNotified']),
      ''
    ),
    dateYouBecame: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateYouBecame']),
      ''
    ),

    nameOfEmployer: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfEmployer']),
      ''
    ),

    dateOfTerminationOrLayoff: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfTerminationOrLayoff']),
      ''
    ),

    howLongWereYouEmployed: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'howLongWereYouEmployed']),
      ''
    ),

    wasThisWorkTransfer: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'wasThisWorkTransfer']),
      ''
    ),
    nameOfCourtOrAuthority: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfCourtOrAuthority']),
      ''
    ),
    dateToAppearInCourt: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateToAppearInCourt']),
      ''
    ),
    nameOfAuthorityHandlingTheIncident: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfAuthorityHandlingTheIncident']),
      ''
    ),
    dateOfIncident: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfIncident']),
      ''
    ),
    chooseAnInsured: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'chooseAnInsured']),
      ''
    ),
    fullName: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'fullName']),
      ''
    ),
    relationshipToTraveler: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'relationshipToTraveler']),
      ''
    ),
    pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled']),
      ''
    ),
    nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure']),
      ''
    ),
    dateOfTransportClosureIncident: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfTransportClosureIncident']),
      ''
    ),
    dateOfTrafficAccident: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfTrafficAccident']),
      ''
    ),
    nameOfTravelSupplier: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfTravelSupplier']),
      ''
    ),
    whenDidOperationsResume: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whenDidOperationsResume']),
      ''
    ),
    whatCausedTheServiceCessation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whatCausedTheServiceCessation']),
      ''
    ),
    whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable']),
      ''
    ),
    whereWasUninhabitable: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whereWasUninhabitable']),
      ''
    ),
    provideDetailsOfTheIncident: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'provideDetailsOfTheIncident']),
      ''
    ),

    // Trip Interruption TI Fields
    whoSickOrInjuredCusingTheCancellationTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whoSickOrInjuredCusingTheCancellationTI']),
      ''
    ),
    whoHadDiedCausingTheCancellationTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whoHadDiedCausingTheCancellationTI']),
      ''
    ),
    nameOfEmployerTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfEmployerTI']),
      ''
    ),
    whenWereYouNotifiedTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whenWereYouNotifiedTI']),
      ''
    ),
    dateOfTerminationOrLayoffTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfTerminationOrLayoffTI']),
      ''
    ),
    howLongWereYouEmployedTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'howLongWereYouEmployedTI']),
      ''
    ),
    wasThisWorkTransferTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'wasThisWorkTransferTI']),
      ''
    ),
    nameOfServiceCallingToActiveDutyTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfServiceCallingToActiveDutyTI']),
      ''
    ),
    dateYouBecameTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateYouBecameTI']),
      ''
    ),
    nameOfCourtOrAuthorityTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfCourtOrAuthorityTI']),
      ''
    ),
    dateToAppearInCourtTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateToAppearInCourtTI']),
      ''
    ),
    nameOfAuthorityHandlingTheIncidentTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfAuthorityHandlingTheIncidentTI']),
      ''
    ),
    dateOfIncidentTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfIncidentTI']),
      ''
    ),
    chooseAnInsuredTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'chooseAnInsuredTI']),
      ''
    ),
    fullNameTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'fullNameTI']),
      ''
    ),
    relationshipToTravelerTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'relationshipToTravelerTI']),
      ''
    ),
    pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI']),
      ''
    ),
    nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI']),
      ''
    ),
    dateOfTransportClosureIncidentTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfTransportClosureIncidentTI']),
      ''
    ),
    dateOfTrafficAccidentTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfTrafficAccidentTI']),
      ''
    ),
    nameOfTravelSupplierTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfTravelSupplierTI']),
      ''
    ),
    whenDidOperationsResumeTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whenDidOperationsResumeTI']),
      ''
    ),
    whatCausedTheServiceCessationTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whatCausedTheServiceCessationTI']),
      ''
    ),
    whenWasThePrimaryResidenceOrDestinationDeemedUninhabitableTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whenWasThePrimaryResidenceOrDestinationDeemedUninhabitableTI']),
      ''
    ),
    whereWasUninhabitableTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'whereWasUninhabitableTI']),
      ''
    ),
    provideDetailsOfTheIncidentTI: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'provideDetailsOfTheIncidentTI']),
      ''
    ),

    // Trip Interruption version 14 and above
    insuredsForInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'insuredsForInterruption']) && changesToYourJourneyStepState.getIn(['form', 'insuredsForInterruption']).toJS(), ''),
    travelSuppliersTravelInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'travelSuppliersTravelInterruption']) && changesToYourJourneyStepState.getIn(['form', 'travelSuppliersTravelInterruption']).toJS(), ''),
    enableTimeInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'enableTimeInterruption']), null),
    lossInformationItems: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'lossInformationItems']) && changesToYourJourneyStepState.getIn(['form', 'lossInformationItems']).toJS(), ''),

    companyNameLoss: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'companyNameLoss']), ''),
    amountPaidLoss: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'amountPaidLoss']), ''),
    currentAmountPaidLoss: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'currentAmountPaidLoss']), ''),
    amountOfLoss: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'amountOfLoss']), ''),
    currentAmountOfLoss: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'currentAmountOfLoss']), ''),
    amountClaimed: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'amountClaimed']), ''),
    currentClaimed: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'currentClaimed']), ''),
    haveYouReceivedReimbursement: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'haveYouReceivedReimbursement']), ''),
    howMuchReceivedReimbursement: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'howMuchReceivedReimbursement']), ''),
    currentReceivedReimbursement: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'currentReceivedReimbursement']), ''),
    fromWhomReceivedReimbursement: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'fromWhomReceivedReimbursement']), ''),
    dateReimbursementReceived: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'dateReimbursementReceived']), ''),
    enableTime: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'enableTime']), null),
    selectedClaimFor: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'selectedClaimFor']) && changesToYourJourneyStepState.getIn(['form', 'selectedClaimFor']).toJS(), ''),

    travelDelay: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'travelDelay']),
      ''
    ),

    delayInformationItems: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'delayInformationItems']) && changesToYourJourneyStepState.getIn(['form', 'delayInformationItems']).toJS(),
      ''
    ),

    reasonsForDelay: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonsForDelay']),
      ''
    ),

    // Missed Connection
    missedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'missedConnection']),
      ''
    ),

    reasonsForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonsForMissedConnection']),
      ''
    ),

    missedConnectionInformationItems: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'missedConnectionInformationItems']) && changesToYourJourneyStepState.getIn(['form', 'missedConnectionInformationItems']).toJS(),
      ''
    ),

    // Fight Aware API
    flightDetailsTravelCancellation: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightDetailsTravelCancellation']).toJS(), ''),
    flightNumber: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightNumber']), ''),
    flightDate: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightDate']), ''),
    typeOfTransportTravelCancellation: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'typeOfTransportTravelCancellation']), ''),

    flightDetailsTravelInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightDetailsTravelInterruption']).toJS(), ''),
    flightNumberTravelInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightNumberTravelInterruption']), ''),
    flightDateTravelInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightDateTravelInterruption']), ''),
    typeOfTransportTravelInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'typeOfTransportTravelInterruption']), ''),

    flightNumberTravelDelay: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightNumberTravelDelay']), ''),
    flightDateTravelDelay: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightDateTravelDelay']), ''),
    flightDetailsTravelDelay: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightDetailsTravelDelay']).toJS(), ''),
    typeOfTransportTravelDelay: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'typeOfTransportTravelDelay']), ''),

    flightNumberMissedConnection: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightNumberMissedConnection']), ''),
    flightDateMissedConnection: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightDateMissedConnection']), ''),
    flightDetailsMissedConnection: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flightDetailsMissedConnection']).toJS(), ''),
    typeOfTransportMissedConnection: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'typeOfTransportMissedConnection']), ''),

    // Cruise Line
    cruiseLineDetailsTravelCancellation: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'cruiseLineDetailsTravelCancellation']).toJS(), ''),
    cruiseLineDetailsTravelInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'cruiseLineDetailsTravelInterruption']).toJS(), ''),
    cruiseLineDetailsTravelDelay: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'cruiseLineDetailsTravelDelay']).toJS(), ''),
    cruiseLineDetailsMissedConnection: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'cruiseLineDetailsMissedConnection']).toJS(), ''),

    // Other Details
    otherDetailsTravelCancellation: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'otherDetailsTravelCancellation']).toJS(), ''),
    otherDetailsTravelInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'otherDetailsTravelInterruption']).toJS(), ''),
    otherDetailsTravelDelay: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'otherDetailsTravelDelay']).toJS(), ''),
    otherDetailsMissedConnection: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'otherDetailsMissedConnection']).toJS(), ''),
  })
);

const makeSelectChangesToYourJourneyStepErrors = () =>
  createSelector(selectChangesToYourJourneyStep, (state) => state.get('errors'));

export {
  makeSelectChangesToYourJourneyStep,
  makeSelectChangesToYourJourneyStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.ChangesToYourJourney/selectors.js